import React from "react";
import { WebSettingsOrganizationMembers } from "../../components/web-settings/web-settings-organization-members";

const OrganizationMembers = () => {
  return <WebSettingsOrganizationMembers />;
};

export default OrganizationMembers;
